export enum SendOrderDeliveryStatusEnum {
  DELIVER_FINISH = '1',
  DELIVER_NOT_FINISH = '2',
}

export const SendOrderDeliveryStatus = [
  { label: '完納', value: SendOrderDeliveryStatusEnum.DELIVER_FINISH },
  { label: '未納', value: SendOrderDeliveryStatusEnum.DELIVER_NOT_FINISH },
];
